
import { RegistrationHorseRequest } from '@/api/auth/myHorseRegistration'
import Vue from 'vue'
import { saleApi } from '@/api/sales'
import { GetSaleDto } from '@/dtos'
import TitlePage from '@/components/TitlePage.vue'
import { handleAxiosException } from '@/api'
import RegistrationDialog from './RegistrationDialog.vue'

export default Vue.extend({
  components: { RegistrationDialog, TitlePage },
  data() {
    return {
      error: '',
      loading: false,
      registrationDialog: {
        active: false,
        sale: {} as GetSaleDto,
      },
      openedSales: [] as GetSaleDto[],
      snackbarSuccessRegistration: {
        active: false,
        message: '',
      },
    }
  },
  methods: {
    register(s: GetSaleDto) {
      this.registrationDialog = {
        sale: s,
        active: true,
      }
    },
    onSuccessRegistration(horse: RegistrationHorseRequest) {
      this.snackbarSuccessRegistration = {
        active: true,
        message: this.$t('success.registration', { name: horse.name }) as string,
      }
      this.$router.push({ query: {} })
    },
    async loadData() {
      this.loading = true
      try {
        this.openedSales = await saleApi.getAllTechnicalSales()
        if (this.registrationSale > 0) {
          const sale = this.openedSales.filter(it => it.id === this.registrationSale)[0]
          if (sale) {
            this.register(sale)
          }
        }
      } catch (err) {
        this.error = this.$t(handleAxiosException(err)) as string
      }
      this.loading = false
    },
  },
  async mounted() {
    this.loadData()

    if (this.$route.query.saleId && this.$route.query.token) {
      await saleApi.findById(parseInt(this.$route.query.saleId as string, 10), this.$route.query.token as string|undefined).then((r) => {
        this.registrationDialog = {
          sale: r,
          active: true,
        }
      }).catch((e) => {
        this.error = this.$t(handleAxiosException(e, (r) => {
          if (r.status === 404) {
            return 'error.invalid_link'
          } else {
            return r.data?.message
          }
        })) as string
      })
    }
  },
  computed: {
    registrationSale() {
      return parseInt(this.$route.query.sale as string ?? '0', 10)
    },
  },
  watch: {
    registrationSale(v) {
      if (v) {
        const sale = this.openedSales.filter(it => it.id === v)[0]
        if (sale) {
          this.registrationDialog = {
            active: true,
            sale,
          }
        }
      } else {
        this.registrationDialog.active = false
      }
    },
  },
})
